// 控制纠错组件是否显示隐藏
import QuestionCorrectionResult from '@api/module/customer/question-correction/models/QuestionCorrectionResult'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({
  namespaced: true,
  name: 'ErrorCorrection',
  store,
  dynamic: true
})
class ErrorCorrection extends VuexModule {
  questionId = ''
  showQuestion = false
  correctionQuestionInfo = new QuestionCorrectionResult()

  /**
   *  保存学员中心主页选择的TAB路径
   * @param ctx
   * @param index
   */
  @Action
  switchError(id?: string) {
    id && this.QUESTION_ID(id)
  }

  @Mutation
  QUESTION_ID(id: string) {
    this.questionId = id
  }
}

export default ErrorCorrection
